import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
import { Text } from "@grandvisionhq/iris-ui";
/* empty css               */
const FilesList = ({ items, className }) => {
  if (!items.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("ul", { className: classnames("files-list", className), "data-t": "files-list" }, items.map((item, index) => /* @__PURE__ */ React.createElement("li", { className: "files-list__item", key: `${item}-${index}`, "data-t": "files-list-item" }, /* @__PURE__ */ React.createElement(Icon, { name: "paperclip", width: 16, height: 16, className: "files-list__item-icon" }), /* @__PURE__ */ React.createElement(Text, { variant: "caption", component: "span", className: "files-list__item-text" }, item))));
};
export {
  FilesList
};
//# sourceMappingURL=FilesList.js.map
